import { render, staticRenderFns } from "./asRegToNuRecieve.vue?vue&type=template&id=7f5bbbd2&scoped=true&"
import script from "./asRegToNuRecieve.vue?vue&type=script&lang=js&"
export * from "./asRegToNuRecieve.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f5bbbd2",
  null
  
)

export default component.exports